import { z } from 'zod';
import { requiredString } from '../../../validation';

export const CareDocumentColumnSchema = z.object({
  header: requiredString('Header is required'),
  values: z.array(z.string().min(1)).optional(),
});

export type CareDocumentColumn = z.infer<typeof CareDocumentColumnSchema>;
